export default "__VITE_ASSET__BYVSjC$v__"